// Global Sold Out Button Management
// This script handles sold out button visibility across all product pages

document.addEventListener('DOMContentLoaded', function() {
  // Only run on pages that have product variant selection
  const addToCartButton = document.getElementById('AddToCart');
  if (!addToCartButton) return;

  // Select all radio inputs that are part of a variant selection
  const allVariantRadios = document.querySelectorAll('input[data-bundle-selector], input[name^="items-"]');
  
  function updateButtonVisibility() {
    let visibleSelectedVariant = null;
    
    // Re-query variant radios to catch any dynamically added elements
    const currentVariantRadios = document.querySelectorAll('input[data-bundle-selector], input[name^="items-"]');

    // Find the one selected radio button that is currently visible
    for (const radio of currentVariantRadios) {
      // A radio is visible if its offsetParent is not null
      if (radio.checked && radio.offsetParent !== null) {
        visibleSelectedVariant = radio;
        break; // Found the one we care about, stop looking
      }
    }

    // If no visible selected variant found, check if we're in a bundle context
    if (!visibleSelectedVariant) {
      const activeBundle = document.querySelector('input[name="bundles-bar"]:checked');
      if (activeBundle) {
        const bundleContainer = activeBundle.closest('.bundle-group, .single-qnt-group');
        const bundleVariants = bundleContainer.querySelectorAll('input[data-bundle-selector]:checked');
        
        // Check if any of the bundle variants are out of stock
        for (const variant of bundleVariants) {
          if (variant.offsetParent !== null) {
            visibleSelectedVariant = variant;
            break;
          }
        }
      }
    }

    // Check the status of the found variant and toggle the button
    if (visibleSelectedVariant && visibleSelectedVariant.hasAttribute('data-out-of-stock')) {
      addToCartButton.style.display = 'none';
      console.log('Button hidden - out of stock variant selected:', visibleSelectedVariant.value);
    } else {
      addToCartButton.style.display = 'flex';
      console.log('Button shown - in stock variant selected or no variant selected');
    }
  }

  // Function to update main image based on active bundle's pre-selected variant
  function updateImageForActiveBundle() {
    const activeBundle = document.querySelector('input[name="bundles-bar"]:checked');
    if (!activeBundle) return;

    const bundleContainer = activeBundle.closest('.bundle-group, .single-qnt-group');
    const preSelectedVariant = bundleContainer.querySelector('input[data-bundle-selector]:checked');
    
    if (preSelectedVariant) {
      const selectedVariantId = parseInt(preSelectedVariant.value, 10);
      const productDataElement = document.querySelector('.wcp_json');
      
      if (productDataElement) {
        const productData = JSON.parse(productDataElement.textContent);
        const selectedVariant = productData.variants.find(v => v.id === selectedVariantId);
        const mainImage = document.getElementById('ProductPhotoImg');
        
        if (selectedVariant && selectedVariant.featured_image && mainImage) {
          mainImage.src = selectedVariant.featured_image.src;
          
          // Update the active thumbnail if needed
          document.querySelectorAll('[data-poplet-image]').forEach(el => {
            if (el.dataset.variantId === selectedVariant.id.toString()) {
              el.children[0].classList.add('active');
            } else {
              el.children[0].classList.remove('active');
            }
          });
        }
      }
    }
  }

  // Listen for changes on all radio buttons to re-run the check
  document.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function() {
      // Add a small delay to ensure DOM updates are complete
      setTimeout(updateButtonVisibility, 10);
    });
  });

  // Listen for bundle navigation (tier switching) changes
  document.querySelectorAll('input[name="bundles-bar"]').forEach(bundleRadio => {
    bundleRadio.addEventListener('change', function() {
      // Add a small delay to ensure DOM updates are complete
      setTimeout(() => {
        updateButtonVisibility();
        updateImageForActiveBundle();
      }, 10);
    });
  });

  // Listen specifically for variant selection within bundles
  document.querySelectorAll('input[data-bundle-selector]').forEach(variantRadio => {
    variantRadio.addEventListener('change', function() {
      // Immediate update when variant is selected
      setTimeout(updateButtonVisibility, 10);
    });
  });

  // Listen for clicks on variant labels (in case the radio change doesn't fire)
  document.querySelectorAll('label[for*="bundle-"]').forEach(label => {
    label.addEventListener('click', function() {
      // Update after click to ensure the radio state has changed
      setTimeout(updateButtonVisibility, 50);
    });
  });

  // Hide sealapps widget when clicking on bundle groups
  document.querySelectorAll('.bundle-group').forEach(bundleGroup => {
    bundleGroup.addEventListener('click', function() {
      const sealappsWidget = document.getElementById('sealapps-bis-widget');
      if (sealappsWidget) {
        sealappsWidget.style.display = 'none';
        console.log('Sealapps widget hidden due to bundle group click');
      }
    });
  });

  // Show sealapps widget when clicking on single quantity group
  document.querySelectorAll('.single-qnt-group').forEach(singleGroup => {
    singleGroup.addEventListener('click', function() {
      const sealappsWidget = document.getElementById('sealapps-bis-widget');
      if (sealappsWidget) {
        sealappsWidget.style.display = 'block';
        console.log('Sealapps widget shown due to single quantity group click');
      }
    });
  });

  // Initial check when the page loads
  updateButtonVisibility();
  updateImageForActiveBundle();
});

// Additional functionality for other product contexts (like collection pages)
document.addEventListener('DOMContentLoaded', function() {
  // Handle sold out variants on collection pages and other product listings
  const productCards = document.querySelectorAll('[data-product-card]');
  
  productCards.forEach(card => {
    const variantSelectors = card.querySelectorAll('input[data-variant-selector]');
    const addToCartBtn = card.querySelector('[data-add-to-cart]');
    
    if (variantSelectors.length > 0 && addToCartBtn) {
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', function() {
          if (this.checked && this.hasAttribute('data-out-of-stock')) {
            addToCartBtn.style.display = 'none';
          } else if (this.checked) {
            addToCartBtn.style.display = 'block';
          }
        });
      });
    }
  });
});
